import React from 'react';
export function HeroSection() {
  const scrollToPurchase = () => {
    document.getElementById('purchase-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full cursor-pointer bg-stone-900" onClick={scrollToPurchase} aria-label="Ir a la sección de compra" data-id="element-77">
      <img src="https://cdn.magicpatterns.com/uploads/gj5NozxYoAsNevMFrWNCTU/ChatGPT_Image_18_mar_2026,_05_41_46_p.m..png" alt="¿Croquetas o Comida Real? La pregunta que podría cambiar la vida de tu perro. Guía para mejorar la salud de tu perro con comida natural." className="w-full h-auto object-cover block" data-id="element-78" />
    </section>;
}